import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=8f713c36&"
import script from "./wallet.vue?vue&type=script&lang=ts&"
export * from "./wallet.vue?vue&type=script&lang=ts&"
import style0 from "./wallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports